var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: _vm.pram.id ? "编辑链接" : "新增链接",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "pram",
              staticClass: "jump-nav-edit-form",
              attrs: { "label-width": "132px", model: _vm.pram },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "链接名称：",
                    prop: "urlName",
                    rules: [
                      {
                        required: true,
                        message: "请填写链接名称",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写链接名称" },
                    model: {
                      value: _vm.pram.urlName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "urlName", $$v)
                      },
                      expression: "pram.urlName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "归属客户：", prop: "customerId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: !_vm.isMiniProgramCustomer,
                        disabled: _vm.isMiniProgramCustomer,
                        placeholder: "请选择归属客户",
                      },
                      model: {
                        value: _vm.pram.customerId,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "customerId", $$v)
                        },
                        expression: "pram.customerId",
                      },
                    },
                    _vm._l(_vm.customerList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "链接类型：",
                    prop: "urlType",
                    rules: [
                      {
                        required: true,
                        message: "请选择链接类型",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        placeholder: "请选择类型",
                        clearable: "",
                      },
                      on: { change: _vm.changeSelect },
                      model: {
                        value: _vm.pram.urlType,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "urlType", $$v)
                        },
                        expression: "pram.urlType",
                      },
                    },
                    _vm._l(_vm.filteredJumpType, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.title, value: item.key },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isMiniProgram
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "AppID：",
                        prop: "urlParam",
                        rules: [
                          {
                            required: true,
                            message: "请填写 AppID",
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: "请输入目标微信小程序 AppID",
                        },
                        model: {
                          value: _vm.pram.urlParam,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "urlParam", $$v)
                          },
                          expression: "pram.urlParam",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#ff9e3e",
                            "line-height": "20px",
                          },
                        },
                        [_vm._v(_vm._s(_vm.exParams.helpTips))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.exParams.hasParams &&
              !_vm.isLypCate &&
              !_vm.isMiniProgram &&
              !_vm.isRsTakeout
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "链接参数：",
                        prop: "urlParam",
                        rules: [
                          {
                            required: true,
                            message: "请填写链接参数",
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请填写链接参数" },
                        model: {
                          value: _vm.pram.urlParam,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "urlParam", $$v)
                          },
                          expression: "pram.urlParam",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: {
                          color: "#ff9e3e",
                          "line-height": "20px",
                        },
                        domProps: { innerHTML: _vm._s(_vm.exParams.helpTips) },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isRsTakeout
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "类型：",
                        prop: "rsBizType",
                        rules: [
                          {
                            required: true,
                            message: "请选择类型",
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择类型" },
                          on: { change: _vm.onRsBizTypeChange },
                          model: {
                            value: _vm.pram.rsBizType,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "rsBizType", $$v)
                            },
                            expression: "pram.rsBizType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "外卖", value: "takeout" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "团购", value: "group" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "酒店", value: "hotel" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isRsTakeout
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "店铺：",
                        prop: "rsStoreId",
                        rules: [
                          {
                            required: true,
                            message: "请选择店铺",
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            filterable: "",
                            remote: "",
                            clearable: "",
                            placeholder: "请选择店铺",
                            "remote-method": _vm.searchRsStore,
                            loading: _vm.rsStoreLoading,
                          },
                          on: {
                            focus: _vm.onRsStoreFocus,
                            change: _vm.syncRsTakeoutUrlParam,
                          },
                          model: {
                            value: _vm.pram.rsStoreId,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "rsStoreId", $$v)
                            },
                            expression: "pram.rsStoreId",
                          },
                        },
                        _vm._l(_vm.rsStoreOptions, function (item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: {
                              label: _vm.formatRsOptionLabel(item),
                              value: item.key,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isRsTakeout
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "店铺类型：",
                        prop: "rsStoreTypeId",
                        rules: [
                          {
                            required: true,
                            message: "请选择店铺类型",
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          key: "rsStoreType-" + _vm.rsBizTypeCode,
                          staticStyle: { width: "100%" },
                          attrs: {
                            filterable: "",
                            remote: "",
                            clearable: "",
                            placeholder: "请选择店铺类型",
                            "remote-method": _vm.searchRsStoreType,
                            loading: _vm.rsStoreTypeLoading,
                          },
                          on: {
                            focus: _vm.onRsStoreTypeFocus,
                            change: _vm.syncRsTakeoutUrlParam,
                          },
                          model: {
                            value: _vm.pram.rsStoreTypeId,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "rsStoreTypeId", $$v)
                            },
                            expression: "pram.rsStoreTypeId",
                          },
                        },
                        _vm._l(_vm.rsStoreTypeOptions, function (item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: {
                              label: _vm.formatRsOptionLabel(item),
                              value: item.key,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isRsTakeout
                ? _c(
                    "el-form-item",
                    { attrs: { label: "一级分类id：", prop: "rsOneId" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: "一级分类id，非必填",
                        },
                        on: { input: _vm.syncRsTakeoutUrlParam },
                        model: {
                          value: _vm.pram.rsOneId,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "rsOneId", $$v)
                          },
                          expression: "pram.rsOneId",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isRsTakeout
                ? _c(
                    "el-form-item",
                    { attrs: { label: "二级分类id：", prop: "rsTwoId" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: "二级分类id，非必填",
                        },
                        on: { input: _vm.syncRsTakeoutUrlParam },
                        model: {
                          value: _vm.pram.rsTwoId,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "rsTwoId", $$v)
                          },
                          expression: "pram.rsTwoId",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: {
                          color: "#ff9e3e",
                          "line-height": "20px",
                        },
                        domProps: { innerHTML: _vm._s(_vm.exParams.helpTips) },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isLypCate
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "类型：",
                        prop: "lypType",
                        rules: [
                          {
                            required: true,
                            message: "请选择类型",
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择类型" },
                          on: { change: _vm.syncLypUrlParam },
                          model: {
                            value: _vm.pram.lypType,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "lypType", $$v)
                            },
                            expression: "pram.lypType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "自营", value: "zy" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "京东", value: "lypJd" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "山姆", value: "lypSam" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isLypCate
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "一级id：",
                        prop: "lypScid",
                        rules: [
                          {
                            required: true,
                            message: "请填写1级id",
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请填写1级id" },
                        on: { input: _vm.syncLypUrlParam },
                        model: {
                          value: _vm.pram.lypScid,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "lypScid", $$v)
                          },
                          expression: "pram.lypScid",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isLypCate
                ? _c(
                    "el-form-item",
                    { attrs: { label: "二级id：", prop: "lypTwoId" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请填写2级id" },
                        on: { input: _vm.syncLypUrlParam },
                        model: {
                          value: _vm.pram.lypTwoId,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "lypTwoId", $$v)
                          },
                          expression: "pram.lypTwoId",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: {
                          color: "#ff9e3e",
                          "line-height": "20px",
                        },
                        domProps: { innerHTML: _vm._s(_vm.exParams.helpTips) },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isMiniProgram
                ? _c(
                    "el-form-item",
                    { attrs: { label: "链接：", prop: "url" } },
                    [
                      _vm.pram && _vm.pram.urlType == "other"
                        ? _c("el-input", {
                            attrs: { clearable: "", placeholder: "请填写url" },
                            model: {
                              value: _vm.pram.url,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "url", $$v)
                              },
                              expression: "pram.url",
                            },
                          })
                        : _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.pram.urlType == "other"
                                  ? _vm.pram.url || "--"
                                  : "" +
                                      (_vm.exParams.baseUrl || "--") +
                                      (_vm.exParams.hasParams &&
                                      _vm.displayUrlParam
                                        ? "?" + _vm.displayUrlParam
                                        : "")
                              )
                            ),
                          ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "权限：",
                    prop: "authority",
                    rules: [
                      {
                        required: true,
                        message: "请选择权限",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.typeDisable, size: "small" },
                      model: {
                        value: _vm.pram.authority,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "authority", $$v)
                        },
                        expression: "pram.authority",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("不设权限"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("指定卡片展示"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("指定卡片不展示"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v("选择不设权限则在对应落地页无需绑定卡片也能展示"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.pram.authority
                ? _c(
                    "el-form-item",
                    { attrs: { label: "指定卡片：", prop: "fuCartIds" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            clearable: "",
                            "remote-method": _vm.remoteMethod,
                            multiple: "",
                            placeholder: "请选择",
                            filterable: "",
                            "filter-method": _vm.handleAgreementSearch,
                          },
                          model: {
                            value: _vm.pram.fuCartIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "fuCartIds", $$v)
                            },
                            expression: "pram.fuCartIds",
                          },
                        },
                        _vm._l(_vm.brandOption, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.card_name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.handerSubmit("pram")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }